import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import {
  ListBox,
  processListBoxDragAndDrop,
  processListBoxData,
  ListBoxToolbar,
} from '@progress/kendo-react-listbox';
import CustomModal from 'commons/modal/CustomModal';
import React, { Fragment, useEffect, useState } from 'react';
import { useLazyGetAnnoncesVigueurQuery } from '../../../../redux/api/cache';
import { copy } from '../../../../commons/models/list';

const TitleSeqItem = (props) => {
  let { dataItem, selected, ...others } = props;
  return (
    <li {...others}>
      <div>
        <span style={{ fontWeight: 'bold' }}>{props.dataItem.titre}</span>
        <br />
        <span>Séquence: {props.dataItem.ann_seq}</span>
        <br />
        <span
          style={{ fontSize: '12px' }}
        >{`${props.dataItem.annv_dt_deb} au ${props.dataItem.annv_dt_fin}`}</span>
      </div>
    </li>
  );
};

export default function CreateAnnonceModal(props) {
  const [annonces, setAnnonces] = useState([]);
  const [openAnnonces, setOpenAnnonces] = useState([]);
  const [getAnnoncesVigueur] = useLazyGetAnnoncesVigueurQuery();
  useEffect(() => {
    async function init() {
      let openAnnonces = await getAnnoncesVigueur({ seq: props.annonce.camp_seq, media: props.media }).unwrap();
      openAnnonces.data.forEach((item) => (item.selected = false));
      setOpenAnnonces(openAnnonces.data);

      let annonces = await getAnnoncesVigueur({ camp_seq: props.annonce.camp_seq, media: props.media }).unwrap();
      let clonedAnnonces = copy(annonces);
      clonedAnnonces.data.forEach((item) => (item.selected = false));
      setAnnonces(clonedAnnonces.data);
    }
    init();
  }, [getAnnoncesVigueur, props.annonce.camp_seq, props.media]);

  return (
    <CustomModal
      width={'50%'}
      title='Lier des annonces'
      onClose={props.toggleDialog}
      body={
        <Fragment>
          <Drop
            save={props.save}
            camp_num={props.annonce.camp_num}
            camp_seq={props.annonce.camp_seq}
            openData={openAnnonces}
            data={annonces}
          ></Drop>
        </Fragment>
      }
    />
  );
}

CreateAnnonceModal.propTypes = {
  annonce: PropTypes.shape({
    camp_seq: PropTypes.any,
    camp_num: PropTypes.any
  }),
  media: PropTypes.string,
  save: PropTypes.func,
  toggleDialog: PropTypes.func,
};

const SELECTED_FIELD = 'selected';
class Drop extends React.Component {
  state = {
    allData: this.props.openData,
    addedData: this.props.data,
    draggedItem: {},
  };

  handleItemClick = (event, data, connectedData) => {
    this.setState({
      ...this.state,
      [data]: this.state[data].map((item) => {
        if (item.ann_seq === event.dataItem.ann_seq) {
          item[SELECTED_FIELD] = !item[SELECTED_FIELD];
        } else if (!event.nativeEvent.ctrlKey) {
          item[SELECTED_FIELD] = false;
        }
        return item;
      }),
      [connectedData]: this.state[connectedData].map((item) => {
        item[SELECTED_FIELD] = false;
        return item;
      }),
    });
  };

  handleToolBarClick = (e) => {
    let result = processListBoxData(
      this.state.allData,
      this.state.addedData,
      e.toolName,
      SELECTED_FIELD
    );

    this.setState({
      allData: result.listBoxOneData.map((e) => {
        return {
          ...e,
          camp_num: this.props.camp_num,
          camp_seq: this.props.camp_seq,
        };
      }),
      addedData: result.listBoxTwoData.map((e) => {
        return { ...e, camp_num: 0, camp_seq: 0 };
      }),
    });
  };

  handleDragStart = (e) => {
    this.setState({
      draggedItem: e.dataItem,
    });
  };

  handleDrop = (e) => {
    let result = processListBoxDragAndDrop(
      this.state.allData,
      this.state.addedData,
      this.state.draggedItem,
      e.dataItem,
      'camp_num'
    );
    this.setState({
      allData: result.listBoxOneData,
      addedData: result.listBoxTwoData,
    });
  };
  render() {
    return (
      <div className=' justify-content-center'>
        <div className='row'>
          <div className='col'>
            <h6>Liée (s)</h6>
            <ListBox
              style={{ height: 350, width: '100%' }}
              data={this.state.allData}
              selectedField={SELECTED_FIELD}
              onItemClick={(e) =>
                this.handleItemClick(e, 'allData', 'addedData')
              }
              onDragStart={this.handleDragStart}
              onDrop={this.handleDrop}
              item={TitleSeqItem}
              toolbar={() => {
                return (
                  <ListBoxToolbar
                    tools={['transferTo', 'transferFrom']}
                    data={this.state.allData}
                    dataConnected={this.state.addedData}
                    onToolClick={this.handleToolBarClick}
                  />
                );
              }}
            />
          </div>
          <div className='col'>
            <h6>Annonce(s) disponible(s)</h6>
            <ListBox
              style={{ height: 350, width: '100%' }}
              data={this.state.addedData}
              selectedField={SELECTED_FIELD}
              onItemClick={(e) =>
                this.handleItemClick(e, 'addedData', 'allData')
              }
              onDragStart={this.handleDragStart}
              onDrop={this.handleDrop}
              item={TitleSeqItem}
            />
          </div>
        </div>
        <div className='k-form-buttons' style={{ marginTop: '1rem' }}>
          <Button
            onClick={(e) => {
              this.props.save(this.state);
            }}
            className='blueButton'
          >
            Enregistrer
          </Button>
        </div>
      </div>
    );
  }
}
